<div *ngIf="started" class="ngx-ui-tour">
  <tour-step-template>
    <ng-template let-step="step">
      <div class="outsideCloseNavSidebar">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="pasi-subtitle" [innerHTML]="step?.title | translate"></div>
          <button *ngIf="step.showClose"
                  class="si-button_icon-black"
                  type="button"
                  (click)="onClickEnd()">
            <i class="icosun-close"></i>
          </button>
        </div>
        <div class="pasi-text"
             [class.mb-3]="step.showPrev || step.showProgress || step.showNext"
             [innerHTML]="step?.content | translate"
        ></div>
        <div class="row align-items-center pasi-gap-v-10">
          <div class="col-12 col-sm-5 order-0">
            <button *ngIf="step.showCancel"
                    class="si-button_secondary w-100"
                    (click)="onClickCancel()">
              <div class="d-flex align-items-center justify-content-center">
                <span>&nbsp;{{'CORE_CANCEL' | translate}}</span>
              </div>
            </button>
            <button *ngIf="step.showPrev && !step.showCancel"
                    class="si-button_secondary w-100"
                    (click)="onClickPrev()"
                    [disabled]="!hasPrev()">
              <div class="d-flex align-items-center justify-content-center">
                <i class="icosun-arrow_left2"></i>
                <span>&nbsp;{{step?.prevBtnTitle | translate}}</span>
              </div>
            </button>
          </div>
          <div *ngIf="step.showProgress" class="col-12 col-sm-2 order-first order-sm-1 text-center">
            <span>{{currentStepNumber}}&nbsp;/&nbsp;{{stepsLength}}</span>
          </div>
          <div class="col-12 col-sm-5 order-2">
            <button *ngIf="step.showStart"
                    class="si-button_main w-100"
                    (click)="onClickStart()">
              <div class="d-flex align-items-center justify-content-center">
                <span>{{'SI_START' | translate}}&nbsp;</span>
              </div>
            </button>
            <button *ngIf="step.showNext && hasNext() && !step.showStart"
                    class="si-button_main w-100"
                    (click)="onClickNext()">
              <div class="d-flex align-items-center justify-content-center">
                <span>{{step?.nextBtnTitle | translate}}&nbsp;</span>
                <i class="icosun-arrow_right"></i>
              </div>
            </button>
            <button *ngIf="step.showEnd && !hasNext() && !step.showStart"
                    class="si-button_main align-items-center justify-content-center w-100"
                    (click)="onClickEnd()">
              <span>{{step?.endBtnTitle | translate}}</span>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </tour-step-template>
</div>
